<template>
  <div class="wrap_file_view w-100 h-100 exclude_close_overlays" :class="[pageable ? 'pageable' : 'pagedisable', checkable ? 'checkable' : 'checkdisble']">
    <div v-if="checkable && this.fileList.length > 1" class="px-2 pb-1 d-flex justify-content-between align-items-center">
      <div class="form-check form-check-sm form-check-custom form-check-solid ms-2">
        <input type="checkbox" class="form-check-input" id="item_all" :true-value="`all`" v-model="checkAll" />
      </div>
      <div class="flex-grow-1 ms-4" :class="[{'invisible': checkedVals.length == 0}]">
        <a class="btn btn-sm btn-light-primary" @click="download(checkedVals)">
          <i class="bi bi-download"></i>{{ $t('다운로드') }}
        </a>
      </div>
      <div :class="[{'invisible': checkedVals.length == 0}]">
        <span class="fs-5 fw-bold me-2" v-text="checkedVals.length"></span>
        <span class="fs-7">Selected</span>
      </div>
    </div>
    <div class="wrap_file px-4 py-2 w-100 overflow-auto" :style="[customStyle]">
      <div v-if="this.fileList == 0" class="d-flex justify-content-center p-5 text-muted">
        {{ this.$t('목록이 없습니다.') }}
      </div>
      <div v-else>
        <transition-group :name="animation ? `list` : ``" tag="div">
          <template v-for="(file, index) of fileList">
            <div :key="file.fileId" v-if="pageable ? (index + 1) >= firstIndex && index < endIndex : true" class="file_item d-flex align-items-center">
              <div v-if="checkable && fileList.length > 1" class="flex-grow-0 form-check form-check-sm form-check-custom form-check-solid me-3">
                <input type="checkbox" class="form-check-input" name="item" :id="`item_${file.fileId}`" :true-value="file.fileId" v-model="checkVals[index]" />
              </div>
              <div class="wrap-thumbnail" :title="file.filename">
                <a @click="previewFile(`${file.url}`, `${file.filename}`, `${file.fileExt}`, `${file.fileId}`)">
                  <b-img v-if="file.thumbUrl" :src="`/ktdp/v1/download/${file.thumbUrl}`"></b-img>
                  <b-img v-else :src="$iconUrl(`${file.fileExt}`)" class="w-35px h-35px"></b-img>
                </a>
              </div>
              <div class="flex-grow-1 flex-start ms-3 area_file_name text-truncate">
                <div class="d-flex justify-content-between align-items-center">
                  <span class="fs-7 fw-bold text-truncate" v-text="file.filename" :title="file.filename"></span>
                </div>
                <div class="fs-9 text-gray-500" v-text="file.size.f('file_size')"></div>
                <div class="fs-9 text-gray-500">                  
                  <span v-text="file.regUserNm"></span>
                  <span class="ms-2" v-text="file.regDt.f('datetime-local')"></span>
                </div>
              </div>
              <div class="flex-grow-0 ms-4 d-flex align-items-center">
                <a v-if="file.thumbUrl" href="#" @click="previewFile(`${file.url}`, `${file.filename}`, `${file.fileExt}`)">
                  <i class="bi bi-eye-fill fs-4 link" :title="$t('미리보기')"></i>
                </a>
                <a href="#" class="ms-3" @click="download([file.fileId])">
                  <i class="bi bi-download fs-4 link" :title="$t('다운로드')"></i>
                </a>
                <a v-if="file.deletable" href="#" class="ms-3" @click="deleteFile(file)">
                  <i class="bi bi-trash-fill fs-4 link" :title="$t('삭제')"></i>
                </a>                
              </div>
            </div>
          </template>
        </transition-group>
      </div>
    </div>
    <div class="wrap_pagination w-100 d-flex justify-content-between align-items-center px-3 pt-2">
      <div>
        <a v-if="writable" href="#" id="fileForm" class="btn btn-icon btn-sm btn-circle btn-light-primary" 
          style="box-shadow: 0px 0px 16px 0px rgba(76, 87, 125, 0.5) !important;" @click.stop="showFileForm()">
          <i class="bi bi-paperclip fs-4"></i>
        </a>
      </div>
      <div v-if="pageable && this.fileList.length > 0">
        <ul class="pagination">
          <li v-for="i in pageCount" :key="i" class="paginate_button page-item">
            <a class="page-link" v-text="i" :class="{ active: i == currentPage }" @click="nextPage(i)"></a>
          </li>
        </ul>        
      </div>
      <div v-if="pageable && this.fileList.length > 0">
        <b-form-select v-model="record" :options="[5, 10, 25]" />
      </div>
    </div>
    <b-popover ref="fileForm" target="fileForm" triggers="click" placement="lefttop" custom-class="file_form exclude_close_overlays">
      <div class="d-flex flex-end pt-1">
        <i class="bi bi-x fs-2 link ms-2 fw-bolder" :title="$t('닫기')" @click="closeFileForm"></i>
      </div>
      <div class="mt-2">
        <FileUploadView :files="this.files" :deleteFileIds="this.deleteFileIds" height="112px"></FileUploadView>
      </div>
      <div class="d-flex flex-end mt-4 mb-2">
        <a class="btn btn-sm btn-secondary" v-text="`닫기`" @click="closeFileForm" />
        <a class="btn btn-sm btn-primary ms-2" v-text="`업로드`" @click="insertFile" />
      </div>
    </b-popover>

    <b-modal v-if="showPdf" modal-class="full" id="MODAL_PREVIEW_FILE" :title="selFile.filename" hide-footer centered>
      <b-embed :src="$url(selFile.url)" allowfullscreen />
    </b-modal>
  </div>
</template>
      
<script>
import FileUploadView from "@/components/cmm/FileUploadView.vue";

export default {
  components: { FileUploadView },
  props: {
    fileList: [],
    customStyle: {},
    pageable: false,
    checkable: { default: () => true },
    writable: { default: () => true },
  },
  data() {
    return {
      files: [],
      deleteFileIds: [],
      autoScroll: true,
      animation: true,
      total: 0, recordPerPage: 5, currentPage: 1, record: 5,
      checkVals: [],
      checkAll: {},
      selFile: {},
      showPdf: false,
    };
  },
  computed: {
    firstIndex() { return (this.currentPage - 1) * this.recordPerPage + 1; },
    endIndex() { return this.recordPerPage * this.currentPage; },
    pageCount() { return Math.ceil(this.total / this.recordPerPage); },
    checkedVals() { return this.checkVals.filter(item => item !== false); }
  },
  watch: {
    fileList: {
      deep: true, 
      handler() {
        this.fileListHandler(false);
      } 
    },
    record: {
      deep: true, 
      handler(newVal, oldVal) {
        this.animation = false;
        const oldFirstIndex = oldVal * (this.currentPage - 1) + 1;
        this.currentPage = Math.floor(oldFirstIndex / newVal) + 1;
        this.recordPerPage = this.record;
        this.setCheckEvent();
      }
    },
  },
  mounted() {
    this.fileListHandler(true);

    this.$root.$on('bv::popover::shown', () => {
    });

    this.$root.$on('bv::popover::hidden', () => {
      this.files = [];
      this.deleteFileIds = [];
    });
  },
  methods: {
    async nextPage(page) {
      this.animation = false;
      this.currentPage = page;
      this.$nextTick(() => {
        this.animation = true;
        this.setCheckEvent();
      });
    },
    async setCheckEvent() {
      if(this.checkable) {
        this.checkAll = {};
        this.checkVals = [];
        this.$nextTick(() => { this.$setCheckEvent(document.getElementById('item_all'), document.getElementsByName('item')); });
      }
    },
    async fileListHandler(direct) {
      this.total = this.fileList.length;
      if(this.currentPage > this.pageCount) this.currentPage = this.pageCount;
      if(this.currentPage < 1) this.currentPage = 1;
      this.setCheckEvent();

      this.closeFileForm();
      if(this.autoScroll) this.scrollBottom(direct ? direct : false);
      this.autoScroll = true;
    },
    async closeFileForm() {
      this.$refs.fileForm.$emit('close')
    },
    async showFileForm() {
      await this.closeFileForm();
      setTimeout(() => { this.$refs.fileForm.$emit('open'); }, 200);
    },
    async scrollBottom(auto) {
      this.closeFileForm();
      this.$nextTick(() => {
        const wrapFileEl = document.querySelector('.wrap_file');
        wrapFileEl.scrollTo({ top: wrapFileEl.scrollHeight, behavior: auto === true ? 'auto' : 'smooth' });
      });
    },
    async insertFile() {
      const files = [];
      for (let file of this.files) {
        files.push(file);
      }
      await this.$emit('insertFile', files);
    },
    async deleteFile(file) {
      this.autoScroll = false;
      await this.$emit('deleteFile', file);
    },
    async download(checkedVals) {
      const urls = this.fileList.filter(item => checkedVals.includes(item.fileId)).map(item => item.url);
      await this.$emit('download', urls);
    },
    async previewFile(url, filename, fileExt, fileId) {
      const fileType = this.$fileType(fileExt);
      this.selFile = {url, filename};
      if(fileType == 'pdf') {
        this.showPdf = true;
        this.$nextTick(() => {
          this.$bvModal.show('MODAL_PREVIEW_FILE');
        });
      } else if(fileType == 'image') {
        const wrapper = document.createElement('div');
        wrapper.classList.add('fullscreen-image', 'exclude_close_overlays');
        wrapper.addEventListener('click', () => { wrapper.remove(); });
        
        wrapper.innerHTML = `
          <img src="${this.$url(this.selFile.url)}" alt="${this.selFile.filename}" class="full-img">
          <span class="close-btn"><i class="bi bi-x fs-2x text-white"></i></span>
        `;
        document.querySelector('body').append(wrapper);
      } else {
        this.download([fileId]);
      }
    },
  },
};
</script>
  
<style scoped>
.file_form {
  min-width: 400px !important;
  font-size: 13px;
  z-index: 103;
}

.wrap_file_view {
  display: flex;
  flex-direction: column;
}

.wrap_file {
  flex-grow: 0;
}

.wrap_pagination {
  flex-grow: 1;  
}

.pagedisable .wrap_pagination {
  position: absolute;
  left: 2px;
  bottom: 10px;
}

.pagedisable .wrap_file {
  padding-bottom: 40px !important;
}

.wrap_file .file_item {
  border: 1px solid var(--kt-gray-300) !important;
  border-radius: .425rem;
  background-color: var(--kt-gray-200);
  padding: 7px 8px 5px 6px;
  margin-bottom: 5px;
}
</style>